import React, { useEffect, useState } from 'react';
import { MdClose, MdCheck } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import { FormHelperTextValidationStyled, FormHelperTextValidationStyledWrapper } from './styles';
import { kebabize } from '../../utils/kebabize';

export default function FormHelperTextValidation({ validation, omitFirst = true }) {
  const { t } = useTranslation();
  const [validationsKeys, setValidationsKeys] = useState();

  function translationKey(key) {
    return kebabize(key)?.replace('-error', '');
  }

  useEffect(() => {
    const keys = omitFirst ? Object.keys(validation)?.slice(1) : Object.keys(validation);

    setValidationsKeys(keys);
  }, [validation, omitFirst]);

  return (
    <FormHelperTextValidationStyledWrapper>
      {validationsKeys?.map((key) => (
        <FormHelperTextValidationStyled
          id={key}
          key={key}
          error={validation[key]}
          data-testid="form-helper-text-validation"
        >
          {validation[key] ? <MdClose /> : <MdCheck />}
          {t(`errors.${translationKey(key)}`)}
        </FormHelperTextValidationStyled>
      ))}
    </FormHelperTextValidationStyledWrapper>
  );
}
